module.exports = __webpack_public_path__ + "static/img/ten-years-of-target-oxbridge.ce7d81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/ten-years-of-target-oxbridge.png
// module id = LyKv
// module chunks = 0